var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPr = function SvgIconPr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 0a11.98 11.98 0 0 0-9.6 4.8h19.2A11.98 11.98 0 0 0 12 0M11.999 24c3.926 0 7.411-1.886 9.6-4.8H2.4a11.98 11.98 0 0 0 9.6 4.8M-.001 12c0 .821.083 1.624.24 2.4h23.52a12.1 12.1 0 0 0 0-4.8H.239C.082 10.374 0 11.176 0 12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.515 3.515c-4.687 4.687-4.687 12.285 0 16.971L12 12.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m4.857 8.869.777 2.391h2.515l-2.035 1.478.777 2.392-2.034-1.478-2.034 1.478.777-2.392-2.035-1.478H4.08z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPr;